import { render } from "./SuperAdminHeader.vue?vue&type=template&id=dc6298d2&scoped=true"
import script from "./SuperAdminHeader.vue?vue&type=script&lang=js"
export * from "./SuperAdminHeader.vue?vue&type=script&lang=js"

import "./SuperAdminHeader.vue?vue&type=style&index=0&id=dc6298d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6298d2"]])

export default __exports__